/**
 * - Run `pnpm localize` to generate translation files.
 * - Run `pnpm lokse` to open the spreashet with translations.
 * - Export here all translations for the app. 🌐
 */

import { languages } from '../config';
import type { Language } from '../types';
import cs from './cs';
import de from './de';
import en from './en';
import es from './es';
import pl from './pl';
import ru from './ru';

export const translations = {
    [languages.EN]: en,
    [languages.CS]: cs,
    [languages.DE]: de,
    [languages.PL]: pl,
    [languages.ES]: es,
    [languages.RU]: ru,
} as const satisfies Record<Language, Record<keyof typeof en, string>>;
